import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.ohyafinance.com";

const parsePathname = (pathname: string) => {
  const parts = pathname.split("/").filter(Boolean);
  return {
    type: parts[0] || null,
    subtype: parts[1] || null,
    category: parts[2] || null,
  };
};

// 各頁面的 meta 資訊配置
const getPageMeta = (pathname: string, params: any) => {
  const routeParams = parsePathname(pathname);
  const { type, subtype } = routeParams;

  if (pathname === "/" || (!type && !subtype)) {
    return {
      title:
        "歐悅金融科技｜企業資產融資・不動產二胎・土地資產活化｜誠信・創新・富足領航",
      description:
        "歐悅集團 (OHYA Group) 旗下金融科技品牌。100% 集團資金直營，非代辦仲介。專注於企業融資、不動產二胎、土地開發與都更整合。從百萬級周轉至億級開發，以實業底蘊，為您提供最靈活的資金解決方案。",
      canonical: `${BASE_URL}/`,
      ogImage: `${BASE_URL}/logo480.png`,
    };
  }

  if (type === "services") {
    console.log("services");
    return {
      title: "核心服務 - 歐悅金融科技",
      description:
        "歐悅金融科技核心服務涵蓋房屋二胎、企業資產與土地開發都更整合融資。不看聯徵看懂真實資產價值，提供千萬至億級彈性方案，並以建設視角支援整合期資金需求。",
      canonical: `${BASE_URL}/services`,
      ogImage: `${BASE_URL}/logo480.png`,
    };
  }

  if (type === "loan") {
    return {
      title: "線上申貸 - 歐悅金融科技",
      description:
        "歐悅金融科技提供房屋二胎、企業資產與土地開發都更整合融資。釋放房產價值即時挹注資金、企業專屬量身訂製大額方案，並結合建設視角解決整合卡關，線上即可提出申貸。",
      canonical: `${BASE_URL}/loan`,
      ogImage: `${BASE_URL}/logo480.png`,
    };
  }

  if (type === "payment-history") {
    return {
      title: "繳款紀錄查詢 - 歐悅金融科技",
      description:
        "歐悅金融科技提供繳款紀錄查詢服務，讓您隨時掌握繳款狀態與相關資訊。",
      canonical: `${BASE_URL}/payment-history`,
      ogImage: `${BASE_URL}/logo480.png`,
    };
  }

  // 預設值（其他頁面）
  return {
    title:
      "歐悅金融科技｜企業資產融資・不動產二胎・土地資產活化｜誠信・創新・富足領航",
    description:
      "歐悅集團 (OHYA Group) 旗下金融科技品牌。100% 集團資金直營，非代辦仲介。專注於企業融資、不動產二胎、土地開發與都更整合。從百萬級周轉至億級開發，以實業底蘊，為您提供最靈活的資金解決方案。",
    canonical: `${BASE_URL}${pathname}`,
    ogImage: `${BASE_URL}/logo480.png`,
  };
};

const PageMeta = () => {
  const location = useLocation();
  const params = useParams();

  const meta = useMemo(() => getPageMeta(location.pathname, params), [
    location.pathname,
    params,
  ]);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.canonical} />
      {meta.ogImage && <meta property="og:image" content={meta.ogImage} />}
      <link rel="canonical" href={meta.canonical} />
    </Helmet>
  );
};

export default PageMeta;
